import React, { useState } from "react";
import { FaEdit, FaTimes } from "react-icons/fa";
import { API_URL } from "../constants";
import { UserTypes } from "../constants";

const MachineComment = ({ comment, machineId, token }) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const [editMode, setEditMode] = useState(false);
  const [newComment, setNewComment] = useState(comment);
  const [initialComment, setInitialComment] = useState(comment);
  const userType = user.type;

  const handleEditClick = () => {
    setEditMode(true);
  };

  const handleInputChange = (event) => {
    setNewComment(event.target.value);
  };

  const handleSaveClick = async () => {
    try {
      const response = await fetch(`${API_URL}/machines/${machineId}`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          commentaire: newComment,
        }),
      });

      if (response.ok) {
        setEditMode(false);
      } else {
        console.error("Erreur lors de la mise à jour du commentaire de la machine");
      }
    } catch (error) {
      console.error("Erreur lors de la mise à jour du commentaire de la machine", error);
    }
  };

  const handleCancelClick = () => {
    setEditMode(false);
    setNewComment(initialComment);
  };

  return (
    <div>
      <h4 className="pt-4 pb-4 text-xl 3xl:text-3xl text-underline">
        {editMode ? (
          <div className="flex flex-col mt-4 w-full max-w-2xl">
            <textarea
              value={newComment}
              onChange={handleInputChange}
              rows={6}
              placeholder="Ajouter un commentaire..."
              className="
                border-2 border-gray-300 rounded-md p-3 mb-4
                w-full
                min-h-[120px]
                resize-y
                focus:outline-none focus:ring-2 focus:ring-blue-400
              "
            />
            <div className="flex gap-2">
              <button
                onClick={handleSaveClick}
                className="bg-loginBordure hover:bg-blue-900 text-white rounded-md px-4 py-2"
              >
                Modifier
              </button>
              <button
                onClick={handleCancelClick}
                className="bg-red-500 hover:bg-red-700 text-white rounded-md px-4 py-2"
              >
                Annuler
              </button>
            </div>
          </div>
        ) : (
          // Sinon, afficher le commentaire avec l'icône d'édition (uniquement pour les utilisateurs de type "SUPER" ou "ADMIN")
          <div>
            <span className="inline-flex text-decoration-none font-light">
              <div className="inline-flex font-bold underline mr-2 text-xs lg:text-xl 3xl:text-3xl">Commentaires : </div>
              {newComment ? (
                <span className="text-xs lg:text-xl 3xl:text-3xl whitespace-pre-wrap break-words">{newComment}</span>
              ) : (
                <span className="text-xs lg:text-xl 3xl:text-3xl">Pas de commentaire</span>
              )}
              {userType === UserTypes.SUPER || userType === UserTypes.ADMIN || userType === UserTypes.CHEFAG ? (
                <FaEdit className="cursor-pointer ml-4 hover:text-blue-500 transition-all duration-200 ease-in-out" onClick={handleEditClick} />
              ) : null}
            </span>
          </div>
        )}
      </h4>
    </div>
  );
};

export default MachineComment;
